import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Typography,
  Row,
  Col,
  Button,
  Input,
  message,
  Modal,
  Table,
} from "antd";
import { platformApi } from "../../../../../api";
const { Item } = Form;
const { Text, Title } = Typography;
import moment from "moment";

const AuthenticationData = ({
  form,
  validityRef,
  clearRef,
  data,
  open,
  close,
  saveHere,
  editable,
  reload,
  id,
}) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const status = [
    { key: "ACCEPTED", title: "Accept" },
    { key: "PENDING", title: "Pending" },
    { key: "REJECTED", title: "Reject" },
  ];
  const [accessories, setAccessories] = useState([]);
  const [authorisedTime, setAuthorisedTime] = useState(null);
  const [isAuthorised, toggleAuthorise] = useState(false);
  const [vehicleImage,setVehicleImage] = useState("");
  const [latestPrice, setLatestPrice] = useState(null);
  const [errorObj, setErrorObj] = useState({});
  if (Object.keys(data).length === 0) {
    data = null
  }

  useEffect(() => {
    if (open) {
      if (open && data?.vehicle?.id) {
        platformApi
          .get(`/api/vehiclePrice/latest/${data.vehicle.id}`)
          .then((res) => {
            if (res.data?.response?.data?.[0]) {
              setLatestPrice(res.data.response.data[0]);
              console.log("latest ",res.data.response.data[0]);
              
            } else {
              setLatestPrice(null);
            }
          })
          .catch((err) => {
            console.error("Error fetching latest vehicle price:", err);
            setLatestPrice(null);
          });
      }
      
      if (data.price) {
        setAuthorisedTime(
          data.authorisedTime
            ? moment(data.authorisedTime).format("DD/MM/YYYY, h:mm:ss a")
            : null
        );
        toggleAuthorise(
          data.bookingStatus === "ACCEPTED" && data.authorisedTime
            ? false
            : true
        );
        setFieldsValue({
          onRoadPrice: data.price.onRoadPrice,
          tempRegister: data.price.tempRegister,
          onRoadDiscount: data.price.onRoadDiscount,
          netRecieveables: data.price.netRecieveables,
          numberPlate: data.price.numberPlate,
          specialNoCharges: data.price.specialNoCharges || 0,
          hypothetication: data.price.hp || 0,
          affidavit: data.price.affidavit || 0,
          loan: data.loan?.loanAmount || 0,
         loanDisbursementAmount: data.loan?.disbursementAmount || 0,
          downPayment: data.loan?.downPayment || 0,
          finalAmount: data.price.finalAmount,
          accessoriesTotalDiscount: data.price.totalDiscount || 0,
          accessoriesTotalAfterDiscount:
            data.price.accessoriesTotalAfterDiscount || 0,
          accessoriesTotalPrice: data.price.accessoriesTotal,
          bookingStatus: data.bookingStatus ?? "PENDING",
        });
        setAccessories(data.accessories);
        setVehicleImage(data.color.url);
        setFieldsValue({});
      }
    }
  }, [open]);
  const validatePage = () => {
    let isValid;
    form.validateFields((validationError) => {
      isValid = validationError === null;
    });
    // if (isValid) {
    //   modalData.digital = digital;
    // }
    return isValid;
  };
  const sendConfirmSMS = () => {
    if (getFieldValue("bookingStatus") === "ACCEPTED")
      platformApi
        .post("/api/sendSms/bookingconfirm", {
          phone: data.customer
            ? data?.customer?.contacts?.[0]?.phone
            : data.customerPhone,
          type: "WhatsApp",
          smsData: {
            link: data.authentication.beforeVerification,
            cname: data.customer ? data.customer.name : data.customerName,
            slex: data.executive,
            bkid: data.bookingId,
            vname: data?.vehicle?.modelName || "",
            dlr: data.branch,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 200) {
            message.success("Message sent successfully");
          } else if (data.code === 401) {
            message.error(data.message);
          } else if (data.code === 400) {
            message.error(data.message);
          } else {
            message.error("Unable to send SMS");
          }
        });
  };
  const clearFields = () => {
    form.resetFields();
    setErrorObj({});
    setAuthorisedTime(null);
    toggleAuthorise(false);
    setAccessories([]);
  };
  const authorise = () => {
    if (getFieldValue("password") === "" || !getFieldValue("password")) {
      setErrorObj({
        ...errorObj,
        password: {
          type: "error",
          message: "Enter Password",
        },
      });
    } else {
      delete errorObj.password;
      setErrorObj(errorObj);
      platformApi
        .post("/api/booking/authorise", {
          password: getFieldValue("password"),
          status: getFieldValue("bookingStatus"),
          bookingId: data.id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            message.success("Booking Status Updated", 2);
            data.authorisedTime = moment(new Date()).format(
              "DD/MM/YYYY, h:mm:ss a"
            );
            data.bookingStatus = getFieldValue("bookingStatus");
            setAuthorisedTime(
              moment(new Date()).format("DD/MM/YYYY, h:mm:ss a")
            );
            // saveHere();
            sendConfirmSMS();
            clearFields();
            close();
            reload();
          } else {
            message.error(res.data.message, 2);
            setErrorObj({
              ...errorObj,
              password: {
                type: "error",
                message: "Password seems to be wrong!!",
              },
            });
          }
        });
    }
  };

  const calculatePriceAfterDiscount = (item) => {
    const { discount, isPercent, quantity } = item;
    const { mrp } = item.accessory;

    const totalPrice = mrp * quantity;
    if (isPercent) {
      return totalPrice - (totalPrice * discount) / 100;
    }

    return totalPrice - discount;
  };

  const columns = [
    {
      title: "Accessory",
      dataIndex: ["accessory", "partName"],
      key: "partName",
      render: (text, record) => record.key === "total" ? <strong>{text}</strong> : text,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text, record) => record.key === "total" ? <strong>{text}</strong> : text,
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      render: (discount, record) => {
        if (record.key === "total") {
          return <strong>₹{accessoriesTotalDiscount.toLocaleString("en-IN")}</strong>;
        }
        return `${record.isPercent ? discount + "%" : "₹" + discount}`;
      },
    },
    {
      title: "Price Before Discount",
      key: "priceBeforeDiscount",
      render: (_, record) => {
        if (record.key === "total") {
          return <strong>₹{accessoriesTotalPrice.toLocaleString("en-IN")}</strong>;
        }
        return `₹${record.accessory.mrp * record.quantity}`;
      },
    },
    {
      title: "Price After Discount",
      key: "priceAfterDiscount",
      render: (_, record) => {
        if (record.key === "total") {
          return <strong>₹{accessoriesTotalAfterDiscount.toLocaleString("en-IN")}</strong>;
        }
        return `₹${calculatePriceAfterDiscount(record)}`;
      },
    },
  ];
  
  // Get totals from API response instead of calculating on front-end
  const accessoriesTotalPrice = data?.price?.accessoriesTotal || 0;
  
  const accessoriesTotalDiscount = data?.price?.totalDiscount || 0;
  
  const accessoriesTotalAfterDiscount = data?.price?.accessoriesTotalAfterDiscount || 0;
  
  const dataSourceWithTotal = [
    ...accessories,
    {
      key: "total",
      accessory: { partName: "TOTAL" },
      quantity: "",
    },
  ];

  return data ? (
    <div>
      <Modal
        wrapClassName="vehicle-form"
        visible={open}
        title={<Title level={4}>Supervisor Authentication</Title>}
        onCancel={() => {
          clearFields();
          close();
        }}
        okButtonProps={{ disabled: !editable }}
        okText={"Authorise"}
        onOk={() => authorise()}
      >
        <Form style={{ marginBottom: "4%" }}>
        <Row gutter={24} align="top">
          <Col span={14}>
            <Text level={2} strong>
              Booking Authorisation
            </Text>
            <br />
            <Text>I hereby authorise the Booking of the Vehicle.</Text>
            <br />
            <Text strong>Vehicle Model:</Text>{" "}
            {data?.vehicle?.modelName ||
              data?.selectedVehicle?.[0]?.vehicleDetail?.modelName || ""}
            <br />
            <Text strong>Vehicle Manufacturer:</Text>{" "}
            {data?.vehicle?.manufacturer?.name ||
              data?.selectedVehicle?.[0]?.vehicleDetail?.manufacturer?.name || ""}
            <br />
            <Text strong style={{ marginTop: "10px" }}>Accessories List:</Text>

            <Table
            dataSource={dataSourceWithTotal}
            columns={columns}
            pagination={false}
            rowKey="key"
            size="small"
            className="accessories-table"
            style={{ width: "100%", marginTop: "15px", marginBottom: "20px" }}
          />
          </Col>
          <Col span={10}>
            {vehicleImage && (
              <div
                style={{
                  textAlign: "center",
                  marginBottom: 20,
                }}
              >
                <img
                  src={vehicleImage}
                  alt="Vehicle"
                  style={{
                    width: "100%",
                    maxWidth: 200,
                    height: 130,
                    objectFit: "cover",
                    borderRadius: 8,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                />
              </div>
            )}
            <Text strong style={{ display: "block", marginBottom: 8 }}>
              Price Breakdown
            </Text>

            <Table
            pagination={false}
            size="small"
            rowKey={(r) => r.key}
            columns={[
              {
                title: "Type",
                dataIndex: "label",
                key: "label",
                render: (label, record) =>
                  record.key === "total" ? <strong>{label}</strong> : label,
              },
              {
                title: "Amount (₹)",
                dataIndex: "value",
                key: "value",
                render: (v, record) => {
                  if (record.key === "total") {
                    return <strong>{Number(v).toLocaleString("en-IN")}</strong>;
                  }
                  return isNaN(v) ? "-" : Number(v).toLocaleString("en-IN");
                },
              },
            ]}
            dataSource={(() => {
              const rows = [
                {
                  key: "showroomPrice",
                  label: "Ex-Showroom Price",
                  value:
                    latestPrice?.showroomPrice ??
                    data?.vehicle?.price?.[0]?.showroomPrice ??
                    0,
                },
                {
                  key: "roadTax",
                  label: "Road Tax",
                  value:
                    latestPrice?.roadTax ?? data?.vehicle?.price?.[0]?.roadTax ?? 0,
                },
                {
                  key: "registrationFee",
                  label: "Registration Fee",
                  value:
                    latestPrice?.registrationFee ??
                    data?.vehicle?.price?.[0]?.registrationFee ??
                    0,
                },
                {
                  key: "handlingCharges",
                  label: "Handling Charges",
                  value: latestPrice?.handlingCharges ?? 0,
                },
                {
                  key: "warrantyPrice",
                  label: "Warranty Price",
                  value:
                    latestPrice?.warrantyPrice ??
                    data?.vehicle?.price?.[0]?.warrantyPrice ??
                    0,
                },
                {
                  key: "insuranceAmount",
                  label: "Insurance Amount",
                  value: (() => {
                    const typeKey = data?.price?.insuranceType;
                    if (typeKey && latestPrice && latestPrice[typeKey] !== undefined) {
                      return latestPrice[typeKey];
                    }
                    if (
                      typeKey &&
                      data?.vehicle?.price?.[0]?.[typeKey] !== undefined
                    ) {
                      return data.vehicle.price[0][typeKey];
                    }
                    return 0;
                  })(),
                },
              ];
              const total = rows.reduce(
                (sum, item) => sum + (Number(item.value) || 0),
                0
              );

              rows.push({
                key: "total",
                label: "Total",
                value: total,
              });

              return rows;
            })()}
            style={{
              width: "100%",
              border: "1px solid #f0f0f0",
              borderRadius: 6,
            }}
          />
          </Col>
        </Row>
          {/* <Row type="flex" justify="space-around">
            <Col span={7}>
              <Form.Item colon={false} label={<Text>Accesories Total</Text>}>
                {getFieldDecorator("accessoriesTotalPrice")(
                  <Input
                    min="0"
                    addonBefore="&#8377;"
                    maxLength={10}
                    disabled={true}
                    placeholder="0"
                  />
                )}
              </Form.Item>
            </Col>

            <Col span={7}>
              <Form.Item
                colon={false}
                label={<Text>Accesories Total Discount</Text>}
              >
                {getFieldDecorator("accessoriesTotalDiscount")(
                  <Input
                    min="0"
                    addonBefore="&#8377;"
                    maxLength={10}
                    disabled={true}
                    placeholder="0"
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item
                colon={false}
                label={<Text>Accesories Total (after discount)</Text>}
              >
                {getFieldDecorator("accessoriesTotalAfterDiscount")(
                  <Input
                    min="0"
                    addonBefore="&#8377;"
                    maxLength={10}
                    disabled={true}
                    placeholder="0"
                  />
                )}
              </Form.Item>
            </Col>
          </Row> */}

          <Row style={{ margin: "10px 0px 10px 0px" }}>
            <br />
            {
              <Text>
                To Customer{" "}
                <Text strong>
                  {data.customer ? data.customer.name : data.customerName}
                </Text>{" "}
                at the Following Prices
              </Text>
            }
            <br />
            <Text strong>
              Payment Mode:{" "}
              <Text>{data.price && data.price.paymentMode.toUpperCase()}</Text>
            </Text>
            <br />
          </Row>
          <Row
            style={{
              display:
                data.loan && data.loan.loanType !== "companyAssist"
                  ? "none"
                  : "block",
            }}
          >
            <Row>
              <Text strong>Finance Charges</Text>
            </Row>
            <Row type="flex" justify="space-between">
              <Col span={7}>
                <Form.Item
                  colon={false}
                  label={<Text>Loan Disbursement Amount</Text>}
                >
                  {getFieldDecorator("loanDisbursementAmount")(
                    <Input
                      addonBefore="&#8377;"
                      disabled={true}
                      placeholder="0"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item colon={false} label={<Text>Loan Amount</Text>}>
                  {getFieldDecorator("loan")(
                    <Input
                      addonBefore="&#8377;"
                      disabled={true}
                      placeholder="0"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item colon={false} label={<Text>Down Payment</Text>}>
                  {getFieldDecorator("downPayment")(
                    <Input
                      addonBefore="&#8377;"
                      disabled={true}
                      placeholder="0"
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Row>
          <Row>
            <br />
            <Text strong>Overall Charges</Text>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span={7}>
              <Form.Item colon={false} label={<Text>On Road Price</Text>}>
                {getFieldDecorator("onRoadPrice")(
                  <Input
                    addonBefore="&#8377;"
                    disabled={true}
                    placeholder="0"
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item
                colon={false}
                label={<Text>Temporary Registration Charges</Text>}
              >
                {getFieldDecorator("tempRegister")(
                  <Input
                    addonBefore="&#8377;"
                    disabled={true}
                    placeholder="0"
                    onBlur={(e) => {
                      // addFinalAmount(e);
                      addFinalAmount({
                        target: { value: 0 },
                      });
                    }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item colon={false} label={<Text>Hypothetication</Text>}>
                {getFieldDecorator("hypothetication")(
                  <Input
                    addonBefore="&#8377;"
                    disabled={true}
                    placeholder="0"
                    onBlur={(e) => {
                      // addFinalAmount(e);
                      addFinalAmount({
                        target: { value: 0 },
                      });
                    }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item
                colon={false}
                label={<Text>Number Plate Charges</Text>}
              >
                {getFieldDecorator("numberPlate")(
                  <Input
                    addonBefore="&#8377;"
                    disabled={true}
                    placeholder="0"
                    onBlur={(e) => {
                      addFinalAmount(e);
                    }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item colon={false} label={<Text>Affidavit Amount</Text>}>
                {getFieldDecorator("affidavit")(
                  <Input
                    addonBefore="&#8377;"
                    disabled={true}
                    placeholder="0"
                    onBlur={(e) => {
                      // addFinalAmount(e);
                      addFinalAmount({
                        target: { value: 0 },
                      });
                    }}
                  />
                )}
              </Form.Item>
            </Col>

            <Col span={7}>
              <Form.Item colon={false} label={<Text>Special No. Charges</Text>}>
                {getFieldDecorator("specialNoCharges")(
                  <Input
                    addonBefore="&#8377;"
                    disabled={true}
                    placeholder="0"
                    onBlur={(e) => {
                      // addFinalAmount(e);
                      addFinalAmount({
                        target: { value: 0 },
                      });
                    }}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span={7}>
              <Form.Item colon={false} label={<Text>On Road Discount</Text>}>
                {getFieldDecorator("onRoadDiscount")(
                  <Input
                    addonBefore="&#8377;"
                    disabled={true}
                    placeholder="0"
                    onBlur={(e) => {
                      // decFinalAmount(e);
                      addFinalAmount({
                        target: { value: 0 },
                      });
                    }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item colon={false} label={<Text>Net Receivables</Text>}>
                {getFieldDecorator("netRecieveables")(
                  <Input
                    addonBefore="&#8377;"
                    disabled={true}
                    placeholder="0"
                    onBlur={(e) => {
                      // decFinalAmount(e);
                      addFinalAmount({
                        target: { value: 0 },
                      });
                    }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item colon={false} label={<Text>Final Amount</Text>}>
                <Row>
                  <Col span={24}>
                    {getFieldDecorator("finalAmount")(
                      <Input
                        addonBefore="&#8377;"
                        disabled={true}
                        placeholder="0"
                      />
                    )}
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span={4}>
              <Item label="Status" colon={false}>
                {getFieldDecorator("bookingStatus")(
                  <Select
                    disabled={!editable}
                    showAction={["click", "focus"]}
                    placeholder="Status"
                  >
                    {status.map((data) => (
                      <Select.Option key={data.key}>{data.title}</Select.Option>
                    ))}
                  </Select>
                )}
              </Item>
            </Col>
            {isAuthorised && (
              <Col span={19}>
                <Form.Item
                  validateStatus={errorObj.password && errorObj.password.type}
                  help={errorObj.password && errorObj.password.message}
                  colon={false}
                  label={<Text>Password</Text>}
                >
                  <Row type="flex" justify="space-between">
                    <Col span={8}>
                      {getFieldDecorator("password")(
                        <Input.Password
                          disabled={!editable}
                          placeholder="Password"
                          onBlur={(event) => {
                            if (event.target.value === "") {
                              setErrorObj({
                                ...errorObj,
                                password: {
                                  type: "error",
                                  message: "Enter Password",
                                },
                              });
                            } else {
                              setErrorObj({});
                            }
                          }}
                        />
                      )}
                    </Col>
                    <Col span={15}>
                      {/* <Button type="primary" onClick={authorise}>
                        Authorise
                  </Button> */}
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
            )}
          </Row>
          <br />
          <Row>
            <Col span={15} marginTop="15px">
              {authorisedTime && (
                <Text>
                  <Text strong>Authorized Time</Text>:{authorisedTime}
                </Text>
              )}
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  ) : (
    ""
  );
};

const WrappedAuthenticationData = Form.create()(AuthenticationData);

export default WrappedAuthenticationData;
